var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wp-page no-auto-scroll-page",on:{"click":_vm.clicked}},[_c('v-runtime-template',{attrs:{"template":_vm.template}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }